"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var DarkIcon = function DarkIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"
  }));
};

DarkIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "feather feather-moon"
};

var LightIcon = function LightIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "12",
    cy: "12",
    r: "5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"
  }));
};

LightIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  className: "feather feather-sun"
};

function DarkModeToggler(_ref) {
  var isDarkMode = _ref.isDarkMode,
      toggleDarkMode = _ref.toggleDarkMode,
      _ref$buttonClassName = _ref.buttonClassName,
      buttonClassName = _ref$buttonClassName === void 0 ? "" : _ref$buttonClassName;
  return /*#__PURE__*/_react["default"].createElement("button", {
    className: buttonClassName,
    onClick: function onClick() {
      return toggleDarkMode(!isDarkMode);
    }
  }, isDarkMode ? /*#__PURE__*/_react["default"].createElement(DarkIcon, null) : /*#__PURE__*/_react["default"].createElement(LightIcon, null));
}

var _default = DarkModeToggler;
exports["default"] = _default;